import React from 'react';
import { PageHero, SectionTitle, Card, Input } from '../components/PageUI';

const BlogPage = () => {
  const posts = Array.from({ length: 9 }).map((_, index) => ({
    title: `Post ${index + 1}: Estratégias para distribuição`,
    category: ['Vendas', 'Finanças', 'Logística'][index % 3],
    excerpt: 'Resumo do conteúdo com insights práticos para gestores.'
  }));

  return (
    <div>
      <PageHero
        eyebrow="Blog Zartoo"
        title="Conteúdos sobre gestão e tecnologia."
        subtitle="Insights sobre ERP, BI, logística e operações inteligentes."
        primaryCta={{ label: 'Assinar newsletter', href: '#newsletter' }}
      />

      <section className="bg-slate-950">
        <div className="container mx-auto px-8 lg:px-12 py-16">
          <SectionTitle
            eyebrow="Conteúdos"
            title="Posts em destaque"
            description="Atualizações semanais para líderes de distribuição."
          />
          <div className="grid lg:grid-cols-[2fr_1fr] gap-8">
            <Card>
              <h3 className="text-2xl font-semibold">Featured: Como integrar ERP, PDV e APP</h3>
              <p className="text-slate-200/80 mt-2">Resumo do post principal com chamada para leitura completa.</p>
              <a href="/blog/como-integrar" className="text-[#4FC3F7] font-semibold mt-3 inline-block">Ler artigo</a>
            </Card>
            <Card>
              <h4 className="text-lg font-semibold mb-3">Categorias</h4>
              <ul className="space-y-2 text-sm text-slate-200/80">
                {['Gestão Empresarial', 'Tecnologia', 'Logística', 'Vendas', 'Finanças'].map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
              <div id="newsletter" className="mt-4">
                <Input label="Newsletter" placeholder="Seu e-mail" />
              </div>
            </Card>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mt-10">
            {posts.map((post) => (
              <Card key={post.title}>
                <p className="text-xs uppercase tracking-wide text-slate-200/60">{post.category}</p>
                <h3 className="text-xl font-semibold mt-2">{post.title}</h3>
                <p className="text-slate-200/80 mt-2">{post.excerpt}</p>
                <a href="/blog/post" className="text-[#4FC3F7] font-semibold mt-3 inline-block">
                  Ler mais
                </a>
              </Card>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default BlogPage;
